import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import {
  Krypton,
  KryptonMenuIcon,
} from 'module/ui/components/templates/krypton';
import {
  faBarsStaggered,
  faFileLines,
  faGear,
  faUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';
import { ROUTE_PATHS } from 'routes/route-paths';
import styled from 'styled-components';

const routePrefixer = (subRoute: string) =>
  `/${ROUTE_PATHS.TEMPLATES}/${subRoute}`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const TemplatesListLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const title = useTranslation('templates.title');
  const meetingPageTemplatesTitle = useTranslation(
    'meeting_page_templates.title',
  );
  const companyPageTemplatesTitle = useTranslation(
    'company_page_templates.title',
  );
  const peoplePageTemplatesTitle = useTranslation(
    'people_page_templates.title',
  );

  const emailPageTemplatesTitle = useTranslation('email_page_templates.title');

  const leftMenuItems = useMemo(
    () => [
      {
        key: 'meeting-page-templates',
        menuName: meetingPageTemplatesTitle,
        menuIcon: <KryptonMenuIcon icon={faFileLines} color={'blue'} />,
        route: routePrefixer(ROUTE_PATHS.MEETING_PAGE_TEMPLATE_LIST),
      },
      {
        key: 'company-page-templates',
        menuName: companyPageTemplatesTitle,
        menuIcon: <KryptonMenuIcon icon={faBarsStaggered} color={'magenta'} />,
        route: routePrefixer(ROUTE_PATHS.COMPANY_PAGE_TEMPLATE_LIST),
      },
      {
        key: 'people-page-templates',
        menuName: peoplePageTemplatesTitle,
        menuIcon: <KryptonMenuIcon icon={faUserGroup} color={'green'} />,
        route: routePrefixer(ROUTE_PATHS.PEOPLE_PAGE_TEMPLATE_LIST),
      },
      {
        key: 'email-page-templates',
        menuName: emailPageTemplatesTitle,
        menuIcon: <KryptonMenuIcon icon={faEnvelope} color={'orange'} />,
        route: routePrefixer(ROUTE_PATHS.EMAIL_PAGE_TEMPLATE_LIST),
      },
    ],
    [
      meetingPageTemplatesTitle,
      companyPageTemplatesTitle,
      peoplePageTemplatesTitle,
      emailPageTemplatesTitle,
    ],
  );

  return (
    <Krypton
      documentTitle={title}
      title={
        <Title>
          <FontAwesomeIcon icon={faGear} />
          {title}
        </Title>
      }
      showSearch={false}
      leftMenuItems={leftMenuItems}
      content={children}
    />
  );
};
